<div
  [ngClass]="{
    main__container: horizontalAutoMargin && pageStyle === defaultPage,
    'main__container--narrow': horizontalAutoMargin && pageStyle === narrowPage
  }"
>
  <div [class]="horizontalOuterMargin ? pageContainerClass : ''">
    <div class="row page__content">
      <div class="col-12">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
